import type { CSSProperties, ReactNode } from "react";

export const page: CSSProperties = {
  fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  maxWidth: 880,
  margin: "0 auto",
  padding: "1.5rem",
  lineHeight: 1.5,
  color: "#1a1a2e",
};

export function Shell({
  title,
  subtitle,
  nav,
  children,
}: {
  title: string;
  subtitle?: string;
  /** Page-level links (back, sign out) — rendered at the top, not the bottom. */
  nav?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div style={page}>
      <header
        style={{
          borderBottom: "1px solid #e6e6ee",
          paddingBottom: "0.75rem",
          marginBottom: "1.5rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
          <img src="/withawill-logo.jpg" alt="WithAWill" style={{ height: 32, width: "auto" }} />
          <strong style={{ letterSpacing: "0.02em" }}>WithAWill Learning Hub</strong>
        </span>
        {nav && <nav style={{ fontSize: "0.9rem" }}>{nav}</nav>}
      </header>
      <h1 style={{ marginBottom: subtitle ? "0.25rem" : "1rem" }}>{title}</h1>
      {subtitle && <p style={{ color: "#555", marginTop: 0 }}>{subtitle}</p>}
      {children}
    </div>
  );
}

export function Card({ children }: { children: ReactNode }) {
  return (
    <section
      style={{
        border: "1px solid #e6e6ee",
        borderRadius: 10,
        padding: "1rem 1.25rem",
        marginTop: "1rem",
      }}
    >
      {children}
    </section>
  );
}
